import axios from "axios";

const { REACT_APP_VEHICLES_API } = process.env;

export const getVehicleUrl = (
  setState: (v) => void,
  filetype: string,
  file: any,
  upload: string,
): void => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  axios({
    method: "get",
    url: `${REACT_APP_VEHICLES_API}/${upload}/${filetype}?use_post=true`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      setState({
        avatarUrl: response.data.data.url + response.data.data.fields.key,
      });
      const options = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const data = new FormData();
      Object.keys(response.data.data.fields).forEach((key) =>
        data.append(key, response.data.data.fields[key]),
      );
      data.append("file", file);
      axios.post(response.data.data.url, data, options);
    })
    .catch((error) => {
      console.error("axios error", error);
    });
};
